/*
  SOLVA — PAGE COLLECTION : barre flottante glass (masquage au scroll) + sélecteur
  de densité (AFFICHAGE) + drawer de filtres (focus trap + Échap). JS vanilla, chargé
  uniquement sur les pages collection (script tag dans la section). reduced-motion :
  pas de masquage de la barre (statique). Filtres = formulaire GET natif (rechargement).
*/
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Barre flottante : masquage au scroll vers le bas, réapparition vers le haut. ---- */
  var bar = document.querySelector('[data-collection-bar]');
  if (bar && !reduce) {
    var lastY = window.scrollY || window.pageYOffset || 0;
    var ticking = false;
    var update = function () {
      var y = window.scrollY || window.pageYOffset || 0;
      if (Math.abs(y - lastY) > 6) {
        if (y > lastY && y > 140) {
          bar.classList.add('is-hidden');
        } else {
          bar.classList.remove('is-hidden');
        }
        lastY = y;
      }
      ticking = false;
    };
    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          window.requestAnimationFrame(update);
          ticking = true;
        }
      },
      { passive: true }
    );
  }

  /* ---- Densité (AFFICHAGE) : bascule 4 ↔ 2 colonnes (desktop), persistée. ---- */
  var grid = document.querySelector('[data-collection-grid]');
  var densityBtns = document.querySelectorAll('[data-density]');
  var DKEY = 'facil_collection_density';
  function applyDensity(d) {
    if (!grid) return;
    grid.classList.toggle('alto-cgrid__grid--wide', d === '2');
    Array.prototype.forEach.call(densityBtns, function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-density') === d ? 'true' : 'false');
    });
    try {
      window.localStorage.setItem(DKEY, d);
    } catch (e) {}
  }
  if (grid && densityBtns.length) {
    var saved = null;
    try {
      saved = window.localStorage.getItem(DKEY);
    } catch (e) {}
    if (saved === '2' || saved === '4') applyDensity(saved);
    Array.prototype.forEach.call(densityBtns, function (b) {
      b.addEventListener('click', function () {
        applyDensity(b.getAttribute('data-density'));
      });
    });
  }

  /* ---- Drawer filtres : ouverture / fermeture, focus trap, Échap. ---- */
  var drawer = document.querySelector('[data-filters-drawer]');
  if (!drawer) return;

  var panel = drawer.querySelector('.alto-cdrawer__panel');
  var openers = document.querySelectorAll('[data-open-filters]');
  var closers = drawer.querySelectorAll('[data-close-filters]');
  var lastFocus = null;
  var isOpen = false;

  function focusables() {
    if (!panel) return [];
    return panel.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
  }

  function onKey(e) {
    if (e.key === 'Escape' || e.key === 'Esc') {
      closeDrawer();
      return;
    }
    if (e.key === 'Tab') {
      var f = focusables();
      if (!f.length) return;
      var first = f[0];
      var last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  }

  function openDrawer() {
    if (isOpen) return;
    isOpen = true;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    Array.prototype.forEach.call(openers, function (o) {
      o.setAttribute('aria-expanded', 'true');
    });
    document.addEventListener('keydown', onKey);
    var f = focusables();
    if (f.length) {
      window.setTimeout(function () {
        try {
          f[0].focus();
        } catch (e) {}
      }, 60);
    }
  }

  function closeDrawer() {
    if (!isOpen) return;
    isOpen = false;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    Array.prototype.forEach.call(openers, function (o) {
      o.setAttribute('aria-expanded', 'false');
    });
    document.removeEventListener('keydown', onKey);
    if (lastFocus && lastFocus.focus) {
      try {
        lastFocus.focus();
      } catch (e) {}
    }
  }

  Array.prototype.forEach.call(openers, function (o) {
    o.addEventListener('click', function (e) {
      e.preventDefault();
      openDrawer();
    });
  });
  Array.prototype.forEach.call(closers, function (c) {
    c.addEventListener('click', function (e) {
      e.preventDefault();
      closeDrawer();
    });
  });
})();
